import { Box, ButtonDropdown, Icon } from '@amzn/awsui-components-react';
import { useIntl } from 'react-intl';

import globeIcon from '../assets/globe.svg';
import globalMessages from '../i18n/global.messages';
import { useLocaleWrapper } from '../contexts/LocaleContextProvider';
import ScreenReaderHidden from './ScreenReaderHidden';
import { getHandleLocaleChange, getLocaleItems } from '../utils/locale';
import { Locales } from '@amzn/xb-hooks';

const idSeparator = ':';

const LocaleMenu = () => {
  const { formatMessage } = useIntl();
  const { locale, setLocale, supportedLocales } =
    useLocaleWrapper('LocaleMenu');
  const supportedLocalesLookup = Locales.lookupFor(supportedLocales);

  return (
    <ButtonDropdown
      items={getLocaleItems(locale.code, idSeparator, supportedLocales)}
      onItemClick={(event) =>
        getHandleLocaleChange(
          event,
          setLocale,
          supportedLocalesLookup,
          idSeparator
        )
      }
      data-testid="header-localeMenu"
    >
      <Box margin={{ right: 'xs' }} display="inline">
        <Icon url={globeIcon} alt="Globe Icon" />
      </Box>
      <ScreenReaderHidden>
        {formatMessage(globalMessages.selectPreferredLocale)}
      </ScreenReaderHidden>
      <ScreenReaderHidden>
        {formatMessage(globalMessages.currentLocaleSelection)}
      </ScreenReaderHidden>
      {locale.displayName}
    </ButtonDropdown>
  );
};

export default LocaleMenu;
